import React from 'react';

const AboutUs = () => {
  return (
    <div className="policy-container">
      <h1>🚀 About Us</h1>

      <h3>Our Mission</h3>
      <p>
        At <strong>GEAR ON</strong>, we believe that every student deserves affordable, accessible, and hassle-free services. Our mission is to empower students by offering convenient solutions like easy rentals for bikes, scooters, and cars.
      </p>

      <h3>Our Values</h3>
      <ul>
        <li>✅ <strong>Student-First:</strong> Designed and run by Gear On, for students.</li>
        <li>✅ <strong>Trust & Transparency:</strong> No hidden costs, data sharing, or third-party usage.</li>
        <li>✅ <strong>Community-Driven:</strong> We listen to your feedback and keep improving.</li>
      </ul>

      <h3>Get in Touch</h3>
      <p>
        Have a question, feedback, or want to collaborate? <br />
        Reach us at <a href="mailto:gearon2426@gmail.com">gearon2426@gmail.com</a>
      </p>
       {/* ✨ New Section Added Below */}
      <p>
        For behind-the-scenes action and daily updates, join us on Instagram! <br />
        Follow us: <a href="https://www.instagram.com/gearon.in?igsh=MWthbzFocW5hZzlveg==" target="_blank" rel="noopener noreferrer">@GearOn.in</a>
      </p>
      <p>
        Together, let’s make student life smarter, simpler, and better — one ride and one lesson at a time.
      </p>
    </div>
  );
};

export default AboutUs;
